import React from 'react';
import { connect } from 'react-redux';
import './BlockMining.css';
import * as actions from '../actions.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
    FormControl,
    Button,
} from 'react-bootstrap';




function BlockMiningDemo({
    dzStart,
    dzEnd,
    sampleData,
    difficulty,
    nonce,
    hashStart,
    hashEnd,
    success,
    autoMining,
    backgroundMining,
    editData,
    adjustDifficulty,
    setNonce,
    autoToggle,
    mineBackground,
}) {
    return (
        <Grid>
            <PageHeader>
                Block Mining Demonstration
            </PageHeader>
            <Row>
                <Col sm={12}>
                    <h3>Data</h3>
                    <textarea
                        id="datainput"
                        name="datainput"
                        rows="3"
                        value={sampleData}
                        onChange={ev => editData(ev.target.value)}
                    ></textarea>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <h3>Difficulty</h3>
                    <FormControl type="number" className="difficultyinput" min="1" max="10" value={difficulty} onChange={ev => adjustDifficulty(ev.target.value)} />
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <h3>Nonce</h3>
                    <FormControl
                        type="number"
                        className={'nonceinput' + (success ? ' nonceinputsuccess' : '')}
                        min="1"
                        value={nonce}
                        onChange={ev => setNonce(ev.target.value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <h3>Resulting Hash</h3>
                    <div className="resultinghash">
                        <span className="resultachieved">{hashStart}</span>
                        {hashEnd}
                    </div>
                    <div className="resultinghash">
                        <span className="resultachieved">{dzStart}</span>
                        {dzEnd}
                        <span className="resulttext"> ← difficulty</span>
                    </div>
                </Col>
            </Row>
            <Row className="autominebuttonbox">
                <Col sm={2}>
                    <Button bsStyle="primary" onClick={autoToggle} disabled={backgroundMining}>{ autoMining ? 'Stop' : 'Auto-mine' }</Button>
                </Col>
                <Col sm={2}>
                    <Button bsStyle="primary" onClick={mineBackground} disabled={autoMining || backgroundMining}>Background</Button>
                </Col>
            </Row>
            {
                success
                ? <Row>
                    <Col sm={12}>
                        <h4 className="successbox">Success</h4>
                    </Col>
                </Row>
                : null
            }
        </Grid>
    );
}

function stateToProps({ mining }) {
    const { hashStart, hashEnd, success } = mining.resultingHash.split('').reduce(function info(acc, digit, index) {
            if( !acc.hashEnd ) {
                if( digit === '0' ) {
                    acc.hashStart += '0';
                    if( acc.hashStart.length >= mining.difficulty ) {
                        acc.success = true;
                    }
                }
                else {
                    acc.hashEnd = mining.resultingHash.slice(index);
                }
            }
            return acc;
        }, { hashStart: "", success: false }),
        dzStart = '0'.repeat( Math.min(hashStart.length, mining.difficulty) ),
        dzEnd = '0'.repeat( mining.difficulty - dzStart.length );

    return {
        ...mining,
        dzStart,
        dzEnd,
        hashStart,
        hashEnd,
        success,
    };
}
function dispatchToProps(dispatch) {
    return {
        editData(content) {
            dispatch(actions.miningEditData(content));
        },
        adjustDifficulty(level) {
            dispatch(actions.miningAdjustDifficulty(level));
        },
        setNonce(value) {
            dispatch(actions.miningSetNonce(value));
        },
        autoToggle() {
            dispatch(actions.miningAutoToggle());
        },
        mineBackground() {
            dispatch(actions.miningBackground());
        },
    };
}

export default connect(stateToProps, dispatchToProps)(BlockMiningDemo);







// WEBPACK FOOTER //
// ./src/components/BlockMining.js